import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export function ProtectedRoute({ children, perm }) {
  const { user, ready, hasPerm } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <Logo size={56} />
        <div className="h-1.5 w-40 bg-slate-200 rounded-full overflow-hidden">
          <div className="h-full w-1/2 bg-[#F4571E] animate-pulse" />
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (perm && !hasPerm(perm)) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center max-w-md">
          <h2 className="text-2xl font-display font-bold text-[#1A2A5E]">Access Restricted</h2>
          <p className="text-slate-500 mt-2">You don't have permission to view this section. Please contact your administrator.</p>
        </div>
      </div>
    );
  }
  return children;
}
